import React, { Component } from 'react'
import { message } from 'hljd'
import { Upload } from '@hlj/hlj-components'
import Style from '../index.module.less'

export default class extends Component {
  onOk = (file, link) => {
    const { onChange } = this.props
    onChange && onChange(link)
  }

  onDel = () => {
    const { onChange } = this.props
    onChange && onChange('')
  }

  onClip = value => {
    const {
      onChange,
      limitSize: { width: limitWidth, height: limitHeight }
    } = this.props
    const { width, height } = value.pixel
    if (width !== limitWidth && height !== limitHeight) {
      return message.error(
        `图片宽度需等于${limitWidth}px，高度需等于${limitHeight}px！`
      )
    }
    onChange && onChange(value.clipUrl)
  }

  onError = (up, err) => {
    message.error('上传失败，请稍候重试！')
  }

  //上传前预处理
  onBeforeUp = async (up, file) => {
    return new Promise((resolve, reject) => {
      const { limitSize } = this.props
      const { height: limitHeight, width: limitWidth } = limitSize
      let reg = /([^/]+)$/
      Upload.checkSize(file, ({ width, height }) => {
        const type = file.type.match(reg)
        if (width != limitWidth || height != limitHeight) {
          message.error(`图片宽度需等于${limitWidth}，高度需等于${limitHeight}`)
          reject(false)
        } else if (type[0] == 'gif' && this.props.isBanner) {
          message.error('图片的格式不正确')
          reject(false)
        } else if (
          type[0] != 'jpeg' &&
          type[0] != 'png' &&
          type[0] != 'bmp' &&
          type[0] != 'gif'
        ) {
          message.error('图片的格式不正确')
          reject(false)
        } else if (file.size > 10240 * 1024) {
          message.error('专题配图的大小超出限制')
          reject(false)
        } else {
          resolve(true)
        }
      })
    })
  }

  // 上传前验证
  validate = file => {
    const {
      limitSize: { width: limitWidth, height: limitHeight }
    } = this.props
    return new Promise((resolve, reject) => {
      Upload.checkSize(file, ({ width, height }) => {
        if (width >= limitWidth && height >= limitHeight) {
          resolve(true)
        } else {
          message.warn(
            `图片宽度需不小于${limitWidth}px，图片高度需不小于${limitHeight}px!`
          )
          reject(false)
        }
      })
    })
  }

  render() {
    const {
      limitSize,
      limitSize: { height, width },
      value,
      isBanner
    } = this.props
    return (
      <div className={Style.upload}>
        <Upload
          clipabled
          onCliped={this.onClip}
          aspect={width / height}
          width={320}
          height={128}
          limitSize={limitSize}
          max_file_size="10mb"
          onOk={this.onOk}
          onError={this.onError}
          showDelete
          onDelete={this.onDel}
          link={value ? value : ''}
          // onBeforeUp={this.onBeforeUp}
          validate={this.validate}
          description={
            <div style={{ lineHeight: '20px', color: '#666' }}>
              <p>上传图片</p>
              <p>{`${width}*${height}px`}</p>
            </div>
          }
          filters={{
            mime_types: [
              {
                title: 'Image files',
                extensions: isBanner
                  ? 'jpg,png,jpeg,bmp'
                  : 'jpg,gif,png,jpeg,bmp'
              }
            ]
          }}
        />
      </div>
    )
  }
}
